import { StateService } from '@uirouter/core';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import * as _ from 'underscore';
import { ISignalRHubProxy, SignalRHubProxyFactory } from '../../../app.common/modules/api/signalRHubProxy.service';
import { AnchorSmoothScrollService } from '../../../app.common/modules/common/services/anchorSmoothScroll.service';
import { AppCueService } from '../../../app.common/modules/common/services/appcue.service';
import { NotificationService } from '../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../app.common/modules/common/services/popup.service';
import { AccountService } from '../account/account.service';
import { IUser } from '../account/model';
import { RetailerService } from '../api/retailer.service';
import { IRetailerRootScope, IRetailerStateData } from './models';

export class CoreController {

    public static $inject = ['$rootScope', '$state', 'accountService', 'anchorSmoothScroll', '$translate', 'signalRHubProxy', '$localStorage', 'notificationService', 'popupService', 'retailerService', 'appCueService'];

    public signalRHubProxy : ISignalRHubProxy;

    constructor(
        private $rootScope: IRetailerRootScope,
        private $state: StateService,
        private accountService: AccountService,
        private anchorSmoothScroll: AnchorSmoothScrollService,
        private $translate: angular.translate.ITranslateService,
        private signalRHubProxyFactory: SignalRHubProxyFactory,
        private $localStorage: ngStorage.StorageService,
        private notificationService: NotificationService,
        private popupService: PopupService,
        private retailerService: RetailerService,
        private appCueService: AppCueService
    ) {
        $rootScope.userData = accountService.userData;
        $rootScope.hasWarnings = (): boolean => {
            if (!$rootScope.userData) {
                return true;
            }

            return $rootScope.userData.retailerStatus === $rootScope.enums.RetailerStatus.Unverified;
        };

        $rootScope.$watch('userData.id', async (userId: number) => {
            if (userId && $rootScope.userData) {
                const isAdmin = await this.accountService.isLoggedInAsAdmin();
                if (!isAdmin) {
                    await this.showPrivacyNotificationIfNeed();
                    const id = $rootScope.userData.permission === $rootScope.enums.RetailerPermission.StoreManager ? 'manager_' + userId : 'retailer_' + userId;
                    appCueService.setUserData(id);
                }
            } else {
                appCueService.resetUserData();
            }
        }, true);

        $rootScope.cancel = ($event: Event): void => {
            $event.preventDefault();
            $event.stopPropagation();
        };

        $rootScope.pageTitle = () => {
            const data = $state.$current.data as IRetailerStateData;
            if (data) {
                return _.isEmpty(data.translateKey) ? data.title : $translate.instant(data.translateKey);
            } else {
                return `${$rootScope.app.name}  ${$rootScope.app.description}`;
            }
        };

        $rootScope.gotoAnchor = (name: string) => {
            anchorSmoothScroll.scrollTo(name, 20);
        };

        $rootScope.$on('Login', this.onLogin);

        $rootScope.$on('LogOut', this.onLogout);

        if ($localStorage.retailerAuthorizationData) {
            this.onLogin();
        }
    }

    private showPrivacyNotificationIfNeed = async () =>  {
        if (this.$rootScope.userData && this.$rootScope.userData.viewedPrivacyNotification === false) {
            try {
                const onButtonAction = await this.popupService.showPrivacyNotification({
                    title: this.$translate.instant('privacy_policy_title'),
                    content: `<p>${this.$translate.instant('privacy_policy_text')}
                              <a href = "${this.$translate.instant('privacy_policy_link')}" target = "_blank"> ${this.$translate.instant('privacy_policy_link_text')} </a>
                              </p>`,
                    okTxt: 'OK',
                    okClass: 'btn-gradient',
                    closeButton: false,
                });
                if (onButtonAction === 'closed') {
                    await this.accountService.updateViewedPrivacyNotification();
                    this.$rootScope.userData.viewedPrivacyNotification = true;
                }
            } catch (e) {
                return;
            }
        }
    }

    private errorHandler = (error: any) => {
        this.notificationService.clearAll();
        this.notificationService.showErrorMessage(error);
    }

    private onLogin = () => {
        const token = this.$localStorage.retailerAuthorizationData
            ? this.$localStorage.retailerAuthorizationData.token
            : null;

        const unwatch = this.$rootScope.$watch('userData', async (userData: IUser) => {
            if (userData.permission) {
                unwatch();
                const isNfrnRetailer = userData.permission === this.$rootScope.enums.RetailerPermission.Nfrn;
                const isPublisherRetailer = userData.permission === this.$rootScope.enums.RetailerPermission.Publisher;
                if (!isNfrnRetailer && !isPublisherRetailer && !this.signalRHubProxy) {
                    this.signalRHubProxy = this.signalRHubProxyFactory(this.retailerService.getSignalREndpoint(), 'RetailerHub');

                    this.signalRHubProxy.on('CampaignVideoProcessingFinish', (campaignVideoID, campaignID) => {
                        this.$rootScope.$broadcast('CampaignVideoProcessingFinish', { CampaignVideoID: campaignVideoID, CampaignID: campaignID });
                    });

                    this.signalRHubProxy.on('CampaignVideoProcessingError', (campaignVideoID, campaignID) => {
                        this.$rootScope.$broadcast('CampaignVideoProcessingError', { CampaignVideoID: campaignVideoID, CampaignID: campaignID });
                    });
                    this.signalRHubProxy.start(token, this.errorHandler);
                }
            }
        }, true);
    }

    private onLogout = () => {
        if (this.signalRHubProxy) {
            this.signalRHubProxy.stop();
            this.signalRHubProxy = null;
        }
    }
}
angular
    .module('naut')
    .controller('CoreController', CoreController);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/core/core.controller.ts